import axios from "axios";
import store from "../app/store";
import { attachApiTracker } from "../analytics/utils/apiTracker";

const BASE_URL = process.env.REACT_APP_API_URL || "https://api.example.com";

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(function (config) {
  const token = store.getState()?.authReducer?.userData?.accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Define common API methods
attachApiTracker(apiClient);

const _get = async (url, params = {}, config = {}) => {
  const requestOptions = { ...config };
  if (params && Object.keys(params).length) {
    requestOptions.params = params;
  }

  return apiClient
    .get(url, requestOptions)
    .then((response) => {
      return {
        ...response,
        statusCode: response?.status,
        data: {
          ...response?.data,
          statusCode: response?.status,
        },
      };
    })
    .catch((error) => {
      return error?.response?.data?.error
        ? { ...error?.response?.data, statusCode: error?.response?.status }
        : {
            data: error?.response?.data,
            error: error?.code,
            message: error?.message,
            status: error?.response?.statusText,
            statusCode: error?.response?.status,
          };
    });
};

const _post = async (url, data = {}, config = {}) => {
  return apiClient
    .post(url, data, config)
    .then((response) => {
      return {
        ...response,
        statusCode: response?.status,
        data: {
          ...response?.data,
          statusCode: response?.status,
        },
      };
    })
    .catch((error) => {
      return error?.response?.data?.error
        ? { ...error?.response?.data, statusCode: error?.response?.status }
        : {
            data: error?.response?.data,
            error: error?.code,
            message: error?.message,
            status: error?.response?.statusText,
            statusCode: error?.response?.status,
          };
    });
};

const _put = async (url, data = {}, config = {}) => {
  return apiClient
    .put(url, data, config)
    .then((response) => {
      return {
        ...response,
        statusCode: response?.status,
        data: {
          ...response?.data,
          statusCode: response?.status,
        },
      };
    })
    .catch((error) => {
      return error?.response?.data?.error
        ? { ...error?.response?.data, statusCode: error?.response?.status }
        : {
            data: error?.response?.data,
            error: error?.code,
            message: error?.message,
            status: error?.response?.statusText,
            statusCode: error?.response?.status,
          };
    });
};

const _delete = async (url, config = {}) => {
  return apiClient
    .delete(url, config)
    .then((response) => {
      return {
        ...response,
        statusCode: response?.status,
        data: {
          ...response?.data,
          statusCode: response?.status,
        },
      };
    })
    .catch((error) => {
      return error?.response?.data?.error
        ? { ...error?.response?.data, statusCode: error?.response?.status }
        : {
            data: error?.response?.data,
            error: error?.code,
            message: error?.message,
            status: error?.response?.statusText,
            statusCode: error?.response?.status,
          };
    });
};

export { _get, _post, _put, _delete };
